<template>
  <panel>
    <attachments
      :schema="$schema"
      :entity-type="entityType"
      :entity-id="entityId"
      :show-radio="false"
      :attachment-type="attachmentType"
      :editable="editable"
      :show-add-from-mdok-button="true"
      :show-download-joined="true"
    >
      <router-link
        v-if="editable && hasViews"
        slot="footer"
        class="btn btn-light ml-2"
        :to="{ name: 'documentGenerate', query: $route.query }"
      >
        Generuj
      </router-link>
    </attachments>
  </panel>
</template>

<script>
import { mapState } from 'vuex';

import Attachments from '@/components/formComponents/attachment/Attachments';
import Panel from '@/components/panel/Panel';
import { AttachmentType } from '@/enums/attachmentType.enum';
import { EntityType } from '@/enums/entityType.enum';
import { formMixin } from '@/mixins/form';
import schema from '@/schemas/documentAttachments.schema';

// @vuese
// Dokumentacja wniosku
// @group Document
export default {
  components: { Attachments, Panel },
  mixins: [formMixin],
  schema,
  data() {
    return {
      entityType: EntityType.DOCUMENT,
      entityId: this.$route.params.documentId.toString(),
      model: {},
      attachmentType: AttachmentType.GENERATED
    };
  },
  computed: mapState({
    stateData: state => ({ attachments: state.document.attachment.list }),
    editable: state => state.auth.checkPermission.permissions['ATTACHMENT.ADD'],
    hasViews: state => !!state.view.list.length
  }),
  watch: {
    stateData(newValue) {
      this.$schema.$setData(newValue, undefined, true);
    }
  },
  mounted() {
    this.stateData.attachments.forEach(attachment => {
      if (attachment?.metadata?.mdokUid) {
        attachment.metadata.mdokUid = parseInt(attachment.metadata.mdokUid);
      }
    });
    this.$schema.$setData(this.stateData);
  }
};
</script>
